WiseMetering.Model.Holiday = WiseMetering.Model.extend({

    urlRoot: '/holidays'

});
